import React, { useState } from 'react';
// import './HowItsWorks.css';

const faqData = [
    {
        title: "How to Start with DocuSafe.ai?",
        content: "Simply click on Try For Free and create your account with us. No credit card required. You will get 3 Sleeves for Trial."
    },
    {
        title: "What is Sleeves?",
        content: "Sleeves is a set of Documents. Create a Sleeves and add a list of Documents in Sleeves for the collection of Documents."
    },
    {
        title: "What is Templates?",
        content: "Templates are your previous Sleeves & you want to use it again. Start with Template and edit them as needed."
    },
    {
        title: "How secure is DocuSafe.ai?",
        content: "DocuSafe.ai uses Bank-grade security. Your documents are stored on the world's No. 1 cloud service provider, AWS."
    }
];

export default function HomeFAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = idx => setOpenIndex(openIndex === idx ? null : idx);

  return (
    <section className="faq-modern-section">
      <div className="container">

     
      {faqData.map((item, idx) => (
        <div className="faq-modern-item" key={idx}>
          <button
            className={`faq-modern-question${openIndex === idx ? ' open' : ''}`}
            onClick={() => toggle(idx)}
            aria-expanded={openIndex === idx}
          >
            <span>{item.title}</span>
            <span className="faq-modern-icon">
              {openIndex === idx ? (
                <span className="faq-modern-minus">
                  <span className="faq-modern-circle">
                    <span className="faq-modern-minus-sign">–</span>
                  </span>
                </span>
              ) : (
                <span className="faq-modern-plus">+</span>
              )}
            </span>
          </button>
          <div
            className="faq-modern-answer"
            style={{
              maxHeight: openIndex === idx ? '200px' : '0',
              padding: openIndex === idx ? '8px 0 16px 0' : '0 0'
            }}
          >
            <p>{item.content}</p>
          </div>
          {idx < faqData.length - 1 && <div className="faq-modern-divider"></div>}
        </div>
      ))}
       </div>
    </section>
  );
} 